// @flow
import { ProcedenciasActionTypes } from './constants';

type ProcedenciasAction = { type: string, payload: {} | string };

// common success
export const procedenciasApiResponseSuccess = (actionType: string, data: any): ProcedenciasAction => ({
    type: ProcedenciasActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const procedenciasApiResponseError = (actionType: string, error: string): ProcedenciasAction => ({
    type: ProcedenciasActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getProcedencia = (id: string): ProcedenciasAction => ({
    type: ProcedenciasActionTypes.GET_PROCEDENCIA,
    payload: { id },
});

export const addProcedencia = (procedencia:any):ProcedenciasAction=>({
    type:ProcedenciasActionTypes.ADD_PROCEDENCIA,
    payload:procedencia
})
export const updateProcedencia = (procedencia:any):ProcedenciasAction=>({
    type:ProcedenciasActionTypes.UPDATE_PROCEDENCIA,
    payload:procedencia
})
export const deleteProcedencia = (id:string):ProcedenciasAction=>({
    type:ProcedenciasActionTypes.DELETE_PROCEDENCIA,
    payload:{id}
})

export const listProcedencias = (params:any): ProcedenciasAction => ({
    type: ProcedenciasActionTypes.LIST_PROCEDENCIAS,
    payload: params,
});

export const setFiltersProcedencias = (params:any): ProcedenciasAction => ({
    type: ProcedenciasActionTypes.SET_FILTER,
    payload: params,
})

export const resetProcedencias = (): ProcedenciasAction => ({
    type: ProcedenciasActionTypes.RESET,
    payload: {},
});

